module.exports = __webpack_public_path__ + "img/ico29.873317de.jpg";